<template>
<div>
  <b-form v-if="!requestOver" @submit.prevent="onSubmit()">
    <b-card v-for="(user, userIdx) of users" v-bind:key="userIdx" no-body border-variant="msstream" class="marginal" style="margin-top:0px; margin-bottom:20px">
      <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
        <h6 style="margin:0px">{{$ml.get('collab1')}} infos </h6>
      </b-card-header>
      <b-card-body>
        <div class="border-success" v-if="user._success" show>{{user._success}}</div>
        <div class="border-error" v-if="user._error" show>{{user._error}}</div>
        <b-form-group id="vodGroup1" label="" label-for="vodInput1">
          <b-input-group size="sm" prepend="Username">
            <b-form-input
              id="vodInput1"
              type="text"
              size="sm"
              v-model.trim="user.username"
              required
              :placeholder="$ml.get('collabname')"
            >
            </b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group id="vodGroup3">
          <b-input-group size="sm" prepend="Email">
            <b-form-input
              type="email" 
              size="sm"
              v-model.trim="user.email"
              :placeholder="$ml.get('collabemail')"
            >
            </b-form-input>
          </b-input-group>
        </b-form-group>
          
        <b-form-group>
          <b-form-checkbox size="sm" v-model="user.isManager" @change="allManager" switch>Account manager</b-form-checkbox>
          <small>{{$ml.get('accmgrrights')}}</small>
        </b-form-group>
        <b-form-group v-if="$auth.getMyUser().client_infos[0].type === 'platform'">
          <b-form-checkbox v-model="user.isEditor" v-if="user.isManager" switch disabled>Videos manager</b-form-checkbox>              
          <b-form-checkbox v-else v-model="user.isEditor" switch>Videos manager</b-form-checkbox>
          <small>{{$ml.get('videomgrrights')}}</small>
        </b-form-group>
      </b-card-body>
    </b-card>
    <!--<b-row class="justify-content-center marginalbotsm">
      <b-col cols="auto">
        <b-button variant="green" @click="addUser">{{$ml.get('addcollab')}}</b-button>
      </b-col>
    </b-row>-->

    <b-row class="justify-content-center">
      <b-button size="sm" type="submit" variant="msstreamblue">
        <font-awesome-icon icon="user-plus" />                
        {{$ml.get('createcollab')}}
      </b-button>
      <!--
      <div class="col-md-2"></div>
      <b-button class="col-md-3" size="sm" @click="onReset()" variant="mswarning">
        <b-icon icon="arrow-repeat" />
        {{$ml.get('reset')}}
      </b-button>
      -->
    </b-row>

  </b-form> 

  <div v-if="requestOver">
    <b-card  v-for="(user, userIdx) of users" v-bind:key="userIdx" no-body border-variant="msstream" class="marginal" style="margin-top:0px; margin-bottom:20px">
        <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
          <h6 style="margin:0px">
            {{$ml.get('collab1')}} 
            <span style="color:#aac8d4">{{user.username}}</span>
            {{$ml.get('created')}}
          </h6>
        </b-card-header>
        <b-card-body>
          <b-alert class="small" variant="success" show>
            {{$ml.get("usercreated")}}<br/><br/>
            <a :href="user.link" target="_blank">{{user.link}}</a>
          </b-alert>
        </b-card-body>
    </b-card>
  </div>

  <b-modal ref="error" hide-footer :title="$ml.get('errcollabc')" >
    <small style="line-height:normal">{{$ml.get('errcollabctxt')}}</small>
    <hr />
    <b-row class="justify-content-around">
      <b-btn size="sm" variant="quanteeclg" @click="hideModal('error')">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
        {{$ml.get('close')}}
      </b-btn>
    </b-row>
  </b-modal>

  <b-modal ref="mail-already-exists" hide-footer :title="$ml.get('errcollabc')" >
    <small style="line-height:normal">{{$ml.get('errcollabcemailtxt')}}</small>
    <hr />
    <b-row class="justify-content-around">
      <b-btn size="sm" variant="quanteeclg" @click="hideModal('mail-already-exists')">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
        {{$ml.get('close')}}
      </b-btn>
    </b-row>
  </b-modal>

  <b-modal ref="error-mail" hide-footer :title="$ml.get('error')" >
    <small>
      {{$ml.get('errorMails')}} 
      {{errorMails}}
    </small>
    <hr />
    <b-row class="justify-content-around">
      <b-btn
        class="col-md-3 col-5"
        size="sm"
        variant="mswarning"
        block
        @click="hideModal('error-mail')"
        >{{$ml.get('close')}}</b-btn
      >
    </b-row>
  </b-modal>

  <b-modal ref="already-exists" hide-footer :title="$ml.get('errcollabc')" >
    <small style="line-height:normal" v-html="$ml.get('errcollabcunametxt')" ></small>
    <hr />
    <b-row class="justify-content-around">
      <b-btn size="sm" class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('already-exists')">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
        {{$ml.get('close')}}
      </b-btn>
    </b-row>
  </b-modal>
  
  <b-modal ref="created" hide-footer :title="$ml.get('newcollabc')" >
    <small style="line-height:normal" v-html="newcollabctxt"></small>
    <hr />
    <b-row class="justify-content-around">
      <b-btn size="sm" class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('created');returnToProfile();">
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
        {{$ml.get('close')}}
      </b-btn>
    </b-row>
  </b-modal>
  
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import UserService from "@/services/user.service";
var userService = new UserService();
export default {
  name: "UserForm",
  data: function () {
    return {
      users: [{
        username: "",
        password: "",
        email: "",
        _error: "",
        _success: "",
        isManager: false,
        isEditor: false,
        client:
          this.$auth.getMyUser().roles.indexOf("admin") > -1
            ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
            : this.$auth.getMyUser().client,
      }],
      requestOver: false,
      newcollabctxt: "",
      defaultUser: {
        username: "",
        password: "",
        email: "",
        _error: "",
        _success: "",
        isManager: false,
        isEditor: false,
        client:
          this.$auth.getMyUser().roles.indexOf("admin") > -1
            ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
            : this.$auth.getMyUser().client,
      },
      errorMails: '',
      newUsername: "",
      newCollaborators: ""
    };
  },
  mounted: function () {},
  methods: {
    validateEmail(email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    onSubmit: function () {
      const reflect = (p, info) => p.then(v => ({ data: v, info: info, success: true }),
            e => ({ error: e, info: info, status: false }));
      let promises = []
      this.users.forEach((user, userIdx) => {
        if (user._success) {
          return;
        }
        delete user._error;
        delete user._success;
        

        if (!user.email || this.validateEmail(user.email)) {
          promises.push(reflect(userService.postUser(this.$auth.token(), user), user));
        } else {
          //this.showModal("error-mail");
          user._error = "Mail invalid";
        }
      })

      Promise.all(promises)
          .then((results) => {
            //this.showModal("created");
            results.forEach((result) => {
              let user = result.info;
              let err = result.error;
              if (result.success) {
                user._success = "User created.";
                user.link = window.location.origin + "/#/signup/" + result.data.signup
                
              } else {
                if (err.response.status != 409) {
                  user._error = "Cannot create the new collaborator. Please try again later or contact Quanteec at: support@quanteec.com."
                  //this.showModal("error");
                } else {
                  if (err.response.data.newUsername) {
                    //this.showModal("already-exists");
                    user._error = `This username ${user.username} is already taken. You can use ${err.response.data.newUsername} instead.`
                    user.username = err.response.data.newUsername;
                    //this.user.username = this.newUsername
                  } else {
                    user._error = `This email is already used by a collaborator.`
                    //this.showModal("mail-already-exists");
                  }
                }
              }
            })
            this.users = this.users.splice(0);
            if (this.users.filter(x => x._success).length > 0) {
              this.$emit("userCreated");
            }
            if (this.users.length  === this.users.filter(x => x._success).length) {
              this.requestOver = true;
              //this.$emit("closeUserCreated");
            }
          })
          .catch((err) => {
          });
    },

    onReset: function () {
      this.users = [{
        username: "",
        password: "",
        _error: "",
        _success: "",
        isManager: false,
        isEditor: false,
        client:
          this.$auth.getMyUser().roles.indexOf("admin") > -1
            ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
            : this.$auth.getMyUser().client,
      }];
    },
    addUser() {
      this.users.push(JSON.parse(JSON.stringify(this.defaultUser)));
    },
    removeUser(idx) {
      this.users.splice(idx, 1);
    },
    returnToProfile: function () {
      this.$emit("userCreated");
    },
    allManager(checked) {
      if (this.user.isManager === true) {
        this.user.isEditor = true
      }
      else {
        this.user.isEditor = false
      }
    }, 
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.border-error {
  border: 1px solid #ba0000;
  border-radius: 10px;
  background-color: rgba(#ba0000, 0.2);
  color: #ba0000;
  padding: 10px;
  margin-bottom: 15px;
}

.border-success {
  border: 1px solid green;
  border-radius: 10px;
  background-color: rgba(green, 0.2);
  color: green;
  padding: 10px;
  margin-bottom: 15px;
}
</style>
